import merge from 'lodash/merge'
import { defaultTheme } from '../helpers/constante'

export default {
  setFusionAuthToken(state, payload) {
    state.fusionAuthToken = payload
  },
  setIsShopManager(state, payload) {
    state.isShopManager = payload
  },
  setIsCustomerService(state, payload) {
    state.isCustomerService = payload
  },
  setIsAdmin(state, payload) {
    state.isAdmin = payload
  },
  setIsOctipasAdmin(state, payload) {
    state.isOctipasAdmin = payload
  },
  setDocumentSettings(state, settings) {
    state.documentSettings = settings
  },
  setCurrentGroup(state, payload) {
    state.currentGroup = payload
  },
  setCurrentStore(state, payload) {
    state.currentStore = payload
  },
  setCurrentStoreDetails(state, payload) {
    state.currentStoreDetails = payload
  },
  SET_DRAWER(state, payload) {
    state.drawer = payload
  },
  SET_MINI(state, payload) {
    state.mini = payload
  },
  SET_LOADING(state, payload) {
    state.loading = payload
  },
  setRoles(state, payload) {
    state.roles = payload
  },
  setRolesUnifiedStock(state, payload) {
    state.rolesUnifiedStock = payload
  },
  setRolesOctiStock(state, payload) {
    state.rolesOctiStock = payload
  },
  setRolesAnalytics(state, payload) {
    state.rolesAnalytics = payload
  },
  setPreviousPath(state, payload) {
    let path = state.previousPath ? state.previousPath.split('/') : []
    let payloadPath = state.payload ? payload.split('/') : []

    if (path && payloadPath && path[path.length - 2] !== payloadPath[payloadPath.length - 2]) {
      state.currentTab = null
    }

    state.previousPath = payload
  },
  setPartnerSettings(state, payload) {
    state.partnerSettings = payload
  },
  setUserEmail(state, payload) {
    state.userEmail = payload
  },
  setUsername(state, payload) {
    state.username = payload
  },
  setIsDark(state, payload) {
    state.isDark = payload
  },
  setBreadcrumbs(state, payload) {
    state.breadcrumbs = payload
  },
  updateBreadcrumb(state, payload) {
    for (let key in payload.value) {
      state.breadcrumbs[payload.index][key] = payload.value[key]
    }
  },
  setCurrentTab(state, payload) {
    state.currentTab = payload
  },
  setUserStores(state, payload) {
    state.userStores = payload
  },
  setAiEnabled(state, payload) {
    state.aiEnabled = payload
  },
  setPartnerTheme(state, payload) {
    state.partnerTheme = merge(
      {},
      {
        default: structuredClone(defaultTheme),
      },
      payload
    )
  },
  setDisplayNavigation(state, payload) {
    state.displayNavigation = payload
  },
  setLocale(state, payload) {
    state.locale = payload
  },
}
